
export default class MenuBackground {
	constructor() {

        const target = document.querySelector('[data-target]');

        if(!target) {
            return;
        }

        this.targetHeight = target.offsetHeight;

		window.addEventListener('scroll', () => {
            this.changeHeaderBackground();
        })
	}

    changeHeaderBackground() {
        this.header = document.querySelector('[data-header-container]');

        const scrollValue = window.scrollY;

        if ( scrollValue < this.targetHeight) {
            this.header.classList.remove('set-background');
        } else {
            this.header.classList.add('set-background');
        }
    }
}
